<template>
  <div class="wrap">

      <audio ref="bgAudio" :src="bgAudio"></audio>
      <img class="logo" v-if="logos.length>0&&logoOn" :style="logoStyle" :src="'http://model.z2ww.com'+logos[logoActiveNum].url" alt="" srcset="">
      <div ref="webgl" class="webgl" :style="{'background-color':bgOn?bgcolor:'','background-image':bgOn?bgActiveImage:''}"></div>
      <div class="rightBox">
        <div class="btn infoBtn">
          <i class="iconfont icon-info_outined" @click="showInfo()"></i>
        </div>
        <div v-if="bgmOn" class="btn music">
          <i v-if="musicOn" class="iconfont icon-music" @click="stopBgm()"></i>
          <i v-if="!musicOn" class="iconfont icon-music_off" @click="playBgm()"></i>
        </div>
        <div v-if="hasAni" class="btn aniBtn">
          <i v-if="aniOn" class="iconfont icon-zanting" @click="stopAni()"></i>
          <i v-if="!aniOn" class="iconfont icon-kaishi" @click="playAni()"></i>
        </div>
        <div class="btn qcode">
          <i class="iconfont icon-erweima" @click="showQcode()"></i>
        </div>
        <div class="btn fullScreen">
          <i v-if="!isFullScreen" class="iconfont icon-fullscreen__2" @click="fullScreen"></i>
          <i v-if="isFullScreen" class="iconfont icon-exit_fullscreen__1" @click="exitFullscreen"></i>
        </div>
      </div>
      <div :class="{'info':true,'active':infoShow}">
        <div class="infoWrap"  @click="closeTip()">
          <h3>{{info.title}}</h3>
          <p v-if="info.type==1" v-html="info.content"></p>
          <img v-if="info.type==3" :src="'http://model.z2ww.com'+info.content">
          <video ref="tipVideo"  v-if="info.type==4" :src="'http://model.z2ww.com'+info.content" controls></video>
          <audio ref="topAudio"  v-if="info.type==5" :src="'http://model.z2ww.com'+info.content" controls></audio>
        </div>
      </div>
      <div class="loading" v-if="!hasLoaded">
        <div class="spinner">
            <div class="spinner-container container1">
                <div class="circle1"></div>
                <div class="circle2"></div>
                <div class="circle3"></div>
                <div class="circle4"></div>
            </div>
            <div class="spinner-container container2">
                <div class="circle1"></div>
                <div class="circle2"></div>
                <div class="circle3"></div>
                <div class="circle4"></div>
            </div>
            <div class="spinner-container container3">
                <div class="circle1"></div>
                <div class="circle2"></div>
                <div class="circle3"></div>
                <div class="circle4"></div>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import axios from 'axios'
import https from '@/https.js'
import '../../public/icons/iconfont.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import zcfCommon from '../../public/com/zcf_common'
let vm=null
export default {
  components: {},
  data() {
    return {
      logoStyle:'',
      logoOn:false,
      logos:[
      ],
      logoActiveNum:0,
      audioIsPlaying:false,
      bgms:[
      ],
      bgmActiveNum:0,
      bgmOn:false,
      activeBgName:'color',
      bgActiveNum:0,
      bgActiveImage:'',
      bgcolor: '#000000',
      bgOn:false,
      cPosX:150,
      cPosY:150,
      cPosZ:150,
      cFov:60,
      cNear:0.01,
      cFar:10000,
      modelInfo:{
      },
      sideTypes: {
        'Front': 'FrontSide',
        'Back': 'BackSide',
        'Double': 'DoubleSide'
      },
      hotPointItemActive:0,
      hotPoints:[],
      modelName:'',
      modelNames:[],
      modelID:'',
      hasLoaded:false,
      musicOn:false,
      bgAudio:'',
      isFullScreen:false,
      info:{
        type:1,
        title:'测试模型',
        content:'我是测试内容'
      },
      infoShow:false,
      qcodeUrl: '',
      hasAni:false,
      aniOn:false
    }
  },
  created() {
    vm = this;
    this.modelID = this.$route.query.id;
    https.fetchGet('/CreateQRcode', {
        link: 'https://model.z2ww.com/dist/sceneView?id='+this.modelID
      }).then(
        res => {
          this.qcodeUrl = res.data
          console.log(this.qcodeUrl)
        },
        err => {
          console.log(err)
        }).catch(error => {
        console.log(error)
      })
  },
  mounted () {
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.lightGroup = new THREE.Group()
    this.lightHelpGroup = new THREE.Group()
    this.pmremGenerator = null
    this.hotPointGroup = new THREE.Group()
    this.modelData = null
    this.selectObj = null
    this.cameraCanControl = true
    this.textrueLoader = new THREE.TextureLoader()
    this.mixer = null
    this.action = null
    this.clock = new THREE.Clock()
    this.init()
  },
  methods: {
    playAni(){
      this.aniOn = true
      this.action.play()
    },
    stopAni(){
      this.aniOn = false
      this.action.stop()
    },
    showQcode(){
      this.infoShow = true
      this.info.type = 3
      this.info.title = '扫一扫'
      this.info.content = this.qcodeUrl
    },
    closeTip(){
      this.infoShow = false
      switch (this.info.type) {
        case 1:
          break;
        case 2:
          break;
        case 3:
          break;
        case 4:
          this.$refs.tipVideo.pause()
          this.$refs.tipVideo.currentTime = 0
          break;
        case 5:
          this.$refs.topAudio.pause()
          this.$refs.topAudio.currentTime = 0
          break;
        default:
          break;
      }
    },
    //全屏
    fullScreen() {
        var element = document.documentElement;
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        }
        this.isFullScreen = true
    },
    //退出全屏 
    exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
        this.isFullScreen = false
    },
    showInfo(){
      this.infoShow = true
      this.info.type = 1
      this.info.title = this.modelName
      this.info.content = this.modelInfo.description
    },
    playBgm(){
      this.musicOn=!this.musicOn
      this.$refs.bgAudio.play()
    },
    stopBgm(){
      this.musicOn=!this.musicOn
      this.$refs.bgAudio.pause()
      this.$refs.bgAudio.currentTime = 0
    },
    changeLogoPos(str){
      switch (str) {
        case 'left top':
          this.logoStyle = 'left:20rem;top:3.4375rem;transform:translateX(0) translateY(0);'
          break;
        case 'mid top':
          console.log(this.containerW )
          console.log(this.$refs.editPanel.getBoundingClientRect().width )
          var left = this.containerW/2 + this.$refs.editPanel.getBoundingClientRect().width
          this.logoStyle = 'left:'+left+'px;top:3.4375rem;transform:translateX(-50%) translateY(0);'
          break;
        case 'left mid':
          this.logoStyle = 'left:20rem;top:50%;transform:translateX(0) translateY(-50%);'
          break;
        case 'right mid':
          this.logoStyle = 'left:100%;top:50%;transform:translateX(-100%) translateY(-50%);'
          break;
        case 'right bottom':
          this.logoStyle = 'left:100%;top:100%;transform:translateX(-100%) translateY(-100%);'
          break;
        default:
          break;
      }
    },
    changeMatAttrOut(str,val){
      this.mesh.getObjectByName(this.nowModelName).material[str] = val
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
    },
    changeBlending(){
      this.mesh.getObjectByName(this.nowModelName).material.blending = THREE[this.modelInfo.models[this.nowModelIndex].blending]
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
    },
    changeSide(){
      this.mesh.getObjectByName(this.nowModelName).material.side = THREE[this.modelInfo.models[this.nowModelIndex].side]
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
    },
    changeMatColor(str,val){
      this.mesh.getObjectByName(this.nowModelName).material[str].set(val)
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
    },
    changeIntensity(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        switch(str){
          case 'aoMap':
            this.mesh.getObjectByName(this.nowModelName).material.aoMapIntensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            break;
          case 'envMap':
            this.mesh.getObjectByName(this.nowModelName).material.envMapIntensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            break;
          case 'lightMap':
            this.mesh.getObjectByName(this.nowModelName).material.lightMapIntensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            break;
          case 'lightMap':
            this.mesh.getObjectByName(this.nowModelName).material.emissiveIntensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            break;
          default:
            break;
        }
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
      }
    },
    changeAnisotropy(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        this.mesh.getObjectByName(this.nowModelName).material[str].anisotropy = this.modelInfo.models[this.nowModelIndex][str].anisotropy
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
      }
    },
    changeBias(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        this.mesh.getObjectByName(this.nowModelName).material.displacementBias = this.modelInfo.models[this.nowModelIndex][str].bias
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
      }
    },
    changeScale(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        switch(str){
          case 'normalMap':
            this.mesh.getObjectByName(this.nowModelName).material.normalScale = new THREE.Vector2(
              this.modelInfo.models[this.nowModelIndex][str].scale,
              this.modelInfo.models[this.nowModelIndex][str].scale
            )
            break;
          case 'displacementMap':
            this.mesh.getObjectByName(this.nowModelName).material.displacementScale = new THREE.Vector2(
              this.modelInfo.models[this.nowModelIndex][str].scale,
              this.modelInfo.models[this.nowModelIndex][str].scale
            )
            break;
          default:
            break;
        }
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate = true
      }
    },
    changeMatAttr(pStr,str,conditionStr,val){
      this.modelInfo.models[this.nowModelIndex][pStr][str]=val
      this[conditionStr]=false
      if(this.modelInfo.models[this.nowModelIndex][pStr].selected){
          this.mesh.getObjectByName(this.nowModelName).material[pStr][str] = this.modelInfo.models[this.nowModelIndex][pStr][str]
          this.mesh.getObjectByName(this.nowModelName).material[pStr].needsUpdate = true
          this.mesh.getObjectByName(this.nowModelName).material.needsUpdate  = true
      }
    },
    changeFlipY(str){
      this.modelInfo.models[this.nowModelIndex][str].flipY = !this.modelInfo.models[this.nowModelIndex][str].flipY
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
          this.mesh.getObjectByName(this.nowModelName).material[str].flipY = this.modelInfo.models[this.nowModelIndex][str].flipY
          this.mesh.getObjectByName(this.nowModelName).material[str].needsUpdate = true
          this.mesh.getObjectByName(this.nowModelName).material.needsUpdate  = true
      }
    },
    changeWireframeUse(str){
      this.modelInfo.models[this.nowModelIndex][str].selected=!this.modelInfo.models[this.nowModelIndex][str].selected
      this.changeWireframe(str)
    },
    changeWireframe(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        this.mesh.getObjectByName(this.nowModelName).material[str] = true
        this.mesh.getObjectByName(this.nowModelName).material.wireframeLinecap = this.modelInfo.models[this.nowModelIndex][str].wireframeLinecap
        this.mesh.getObjectByName(this.nowModelName).material.wireframeLinejoin = this.modelInfo.models[this.nowModelIndex][str].wireframeLinejoin
        this.mesh.getObjectByName(this.nowModelName).material.needsUpdate  = true
      }
    },
    changeMapUse(str){
      this.modelInfo.models[this.nowModelIndex][str].selected=!this.modelInfo.models[this.nowModelIndex][str].selected
      this.changeMatMap(str)
    },
    changeMatMap(str){
      if(this.modelInfo.models[this.nowModelIndex][str].selected){
        if(this.modelInfo.models[this.nowModelIndex][str].url!=''){
          if(str=='envMap'){
            var texture = this.textrueLoader.load(this.modelInfo.models[this.nowModelIndex][str].url,(texture)=>{
              texture.encoding = THREE.GammaEncoding
              this.mesh.getObjectByName(this.nowModelName).material.envMap = this.pmremGenerator.fromEquirectangular(texture).texture
              // this.mesh.getObjectByName(this.nowModelName).material.envMap.needsUpdate = true
              this.changeIntensity('envMap')
            }) 
          }else{
            var texture = this.textrueLoader.load(this.modelInfo.models[this.nowModelIndex][str].url)
            texture.encoding = THREE.GammaEncoding
            texture.wrapT = texture.wrapS = THREE.RepeatWrapping
            texture.flipY = this.modelInfo.models[this.nowModelIndex][str].flipY
            if(this.modelInfo.models[this.nowModelIndex][str].magFilter!=''){
              texture.magFilter = THREE[this.modelInfo.models[this.nowModelIndex][str].magFilter]
            }
            if(this.modelInfo.models[this.nowModelIndex][str].minFiter!=''){
              texture.minFiter = THREE[this.modelInfo.models[this.nowModelIndex][str].minFiter]
            }
            if(this.modelInfo.models[this.nowModelIndex][str].anisotropy!=1){
              texture.anisotropy = THREE[this.modelInfo.models[this.nowModelIndex][str].anisotropy]
            }
            this.mesh.getObjectByName(this.nowModelName).material[str] = texture
            if(this.modelInfo.models[this.nowModelIndex][str].intensity){
              this.mesh.getObjectByName(this.nowModelName).material[str].intensity = this.modelInfo.models[this.nowModelIndex][str].intensity
            }
            if(this.modelInfo.models[this.nowModelIndex][str].scale){
              switch(str){
                case 'normalMap':
                  this.mesh.getObjectByName(this.nowModelName).material.normalScale = new THREE.Vector2(
                    this.modelInfo.models[this.nowModelIndex][str].scale,
                    this.modelInfo.models[this.nowModelIndex][str].scale
                  )
                  break;
                case 'displacementMap':
                  this.mesh.getObjectByName(this.nowModelName).material.displacementScale = new THREE.Vector2(
                    this.modelInfo.models[this.nowModelIndex][str].scale,
                    this.modelInfo.models[this.nowModelIndex][str].scale
                  )
                  break;
                default:
                  break;
              }
            }
            if(this.modelInfo.models[this.nowModelIndex][str].bias){
              this.mesh.getObjectByName(this.nowModelName).material[str].bias = this.modelInfo.models[this.nowModelIndex][str].bias
            }
          }
        }
      }else{
        this.mesh.getObjectByName(this.nowModelName).material[str].dispose()
        this.mesh.getObjectByName(this.nowModelName).material[str] = null
      }
      this.mesh.getObjectByName(this.nowModelName).material.needsUpdate  = true
    },
    changeVolume(num){
      this.$refs['audio'+num][0].volume = this.bgms[num].volume/100
    },
    playAudio(num){
      this.audioIsPlaying = !this.audioIsPlaying
      this.$refs['audio'+num][0].play()
    },
    pauseAudio(num){
      this.audioIsPlaying = !this.audioIsPlaying
      this.$refs['audio'+num][0].pause()
    },
    saveCameraToHotPiont(num){
      this.$confirm('是否将当前相机视角保存为该热点数据的相机状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.hotPoints[num].cPosX = this.camera.position.x;
          this.hotPoints[num].cPosY = this.camera.position.y;
          this.hotPoints[num].cPosZ = this.camera.position.z;
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    deleteHotPiont(num){
      this.$confirm('确定删除此热点数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.hasSelected = false
          this.transformControls.detach(this.selectObj)
          this.hotPoints.splice(num,1);
          this.hotPointItemActive = 0;
          zcfCommon.removeChildFromGroup(this.hotPointGroup)
          for (let i = 0 ; i < this.hotPoints.length; i++){
            this.initHotPiont(this.hotPoints[i],i)
          }
          this.selectObj = this.scene.getObjectByName(this.hotPoints[this.hotPointItemActive].hotTitle+this.hotPointItemActive)
          this.transformControls.attach(this.selectObj)
          this.hasSelected = true
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    uploadHotPointFile(str) {
      let file = this.$refs[str + 'Input'].files[0]
      console.log(file)
      var formData = new FormData()
      formData.append('file', file)
      formData.append('hashvalue', '')
      let config = { headers: { 'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundary' + new Date().getTime() } }
      axios.post('/api/APFAPI/UploadFile', formData, config).then(res => {
        if(res.data.filePath) {
          this.hotPoints[this.hotPointItemActive].hotContent = res.data.filePath
        }
      })
    },
    uploadBGM(str) {
      if(this.bgms.length>=1){
        this.$message({
          type: 'warning',
          message: '上传的背景音乐超限，请升级您的账户等级!'
        });   
      }else{
        let file = this.$refs[str + 'Input'].files[0]
        console.log(file)
        var formData = new FormData()
        formData.append('file', file)
        formData.append('hashvalue', '')
        let config = { headers: { 'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundary' + new Date().getTime() } }
        axios.post('/api/APFAPI/UploadFile', formData, config).then(res => {
          if(res.data.filePath) {
            var arr= res.data.filePath.split('/');
            console.log(arr)
            var name = arr[arr.length - 1].replace('.mp3','')
            console.log(name)
            var json = {
              url: res.data.filePath,
              name: name,
              loop: false,
              volume: 100
            }
            this.bgms.push(json)
            // this.hotPoints[this.hotPointItemActive].hotContent = res.data.filePath
          }
        })
      }
    },
    uploadLogo(str) {
      if(this.logos.length>=1){
        this.$message({
          type: 'warning',
          message: '上传的LOGO超限，请升级您的账户等级!'
        });   
      }else{
        let file = this.$refs[str + 'Input'].files[0]
        console.log(file)
        var formData = new FormData()
        formData.append('file', file)
        formData.append('hashvalue', '')
        let config = { headers: { 'Content-Type': 'multipart/form-data;boundary=----WebKitFormBoundary' + new Date().getTime() } }
        axios.post('/api/APFAPI/UploadFile', formData, config).then(res => {
          if(res.data.filePath) {
            var arr= res.data.filePath.split('/');
            console.log(arr)
            var name = arr[arr.length - 1]
            console.log(name)
            var json = {
              url: res.data.filePath,
              name: name,
              pos: 'left top'
            }
            this.logos.push(json)
            // this.hotPoints[this.hotPointItemActive].hotContent = res.data.filePath
          }
        })
      }
    },
    //弹窗
    showSnackbar(str) {
      this.logText = str
      this.snackbar = true
      console.log(this.selectObj)
    },
    //删除物体
    deleteLight(json) {
      console.log(json)
      var index = this.modelInfo.modelsLight.indexOf(json)
      console.log(index)
      if (index > -1) {
        this.modelInfo.modelsLight.splice(index, 1)
      }
    },
    //添加灯光
    addLight(json) {
      console.log(json)
      this.modelInfo.modelsLight.push(json)
      switch(json.type) {
        case 'AmbientLight':
          let ambientLight = new THREE.AmbientLight(json.color)
          ambientLight.name = json.name
          ambientLight.userData.id = json.id
          this.lightGroup.add(ambientLight)
          console.log(ambientLight)
          break
        case'DirectionalLight':
          let directionalLight = new THREE.DirectionalLight(json.color, json.intensity)
          directionalLight.name = json.name
          directionalLight.userData.id = json.id
          directionalLight.position.set(json.posX, json.posY, json.posZ)
          this.lightGroup.add(directionalLight)
          let directionalLightHelp = new THREE.DirectionalLightHelper(directionalLight, 0.2)
          directionalLightHelp.name = json.name + '_1'
          directionalLightHelp.userData.id = json.id
          this.lightHelpGroup.add(directionalLightHelp)
          break
        default:
          break
      }
      console.log(this.lightGroup)
    },
    //根据材质checkbox改变材质是否作用
    changeMapUseful(prop, val, url) {
      console.log(prop, val, url)
      if(val) {
        // var texture = new THREE.TextureLoader().load('http://localhost:5263' + url)
        // texture.
        // this.selectObj.material[prop] = texture
        // this.selectObj.material.needsupdate = true
        // console.log(this.selectObj.material)
        this.changeMaterial(prop, '' + url)
      }else{
        // this.selectObj.material[prop] = null
        var mat = this.selectObj.material.clone()
        this.selectObj.material.dispose()
        this.selectObj.material = null
        mat[prop] = null
        this.selectObj.material = mat
        // this.selectObj.material = new THREE.MeshStandardMaterial()
        // console.log(this.selectObj.material[prop])
      }
    },
    //根据面板操作改变场景中材质
    changeMaterial(prop, val) {
      console.log(prop, val)
      switch(prop) {
        case 'color':
          this.selectObj.material.color.set(val)
          break
        case 'roughness':
        case 'metalness':
        case 'opacity':
        case 'alphaTest':
        case 'displacementScale':
        case 'envMapIntensity':
        case 'lightMapIntensity':
        case 'aoMapIntensity':
          this.selectObj.material[prop] = parseFloat(val)
          break
        case 'transparent':
        case 'wireframe':
        case 'depthTest':
        case 'depthWrite':
          this.selectObj.material[prop] = val
          break
        case 'normalScale':
          this.selectObj.material.normalScale = new THREE.Vector2(val, val)
          break
        case 'side':
          console.log(val)
          this.selectObj.material[prop] = this.sideTypes[val]
          console.log(this.selectObj)
          break
        case 'map':
        case 'normalMap':
        case 'displaceMap':
        case 'roughnessMap':
        case 'metalnessMap':
        case 'lightMap':
        case 'aoMap':
        case 'emissiveMap':
        case 'alphaMap':
          console.log(this.selectObj.material)
          var texture = new THREE.TextureLoader().load(val)
          texture.encoding = THREE.GammaEncoding
          if(this.modelInfo.sceneType === 'gltf') {
            texture.flipY = false
          }
          var mat = this.selectObj.material.clone()
          this.selectObj.material.dispose()
          this.selectObj.material = null
          mat[prop] = texture
          this.selectObj.material = mat
          break
        case 'envMap':
          new THREE.TextureLoader().load(val, (texture) => {
            texture.encoding = THREE.GammaEncoding
            var mat = this.selectObj.material.clone()
            this.selectObj.material.dispose()
            this.selectObj.material = null
            mat[prop] = texture
            mat[prop] = this.pmremGenerator.fromEquirectangular(texture).texture
            this.selectObj.material = mat
          })
          break
        default:
          break
      }
      console.log(this.selectObj.material)
    },
    //改变物体的接受和产生阴影属性
    changeShadow(str, val) {
      this.selectObj[str] = val
    },
    //改变相机状态
    changeCamera(str, val) {
      this.camera[str] = val
      console.log(this.camera)
      this.camera.updateProjectionMatrix()
      this.controls.update()
      this.render()
    },
    //改变灯光强度
    changeLightIntensity(val) {
      console.log(val)
      if(val > 0 && val <= 10.0) {
        this.selectObj.intensity = val
      }else{
        this.logText = '请输入0到10之间的数值'
        this.snackbar = true
      }
    },
    //改变灯光颜色
    changeLightColor(val) {
      console.log(this.selectObj)
      this.selectObj.color.set(val)
    },
    //根据编辑面板的数据来操作选中物体的位置缩放和旋转和阴影属性
    posSelectObj(prop, str, val) {
      if(prop === 'rotation') {
        val = Math.PI * val / 180
      }
      this.mesh[prop][str] = val
      // if(this.selectObj.name === 'camera') {
      //   this.camera.updateProjectionMatrix()
      //   this.controls.update()
      // }
    },
    //操作相机
    posCamera(prop, str, val) {
      if(prop === 'fov') {
        this.camera[prop] = val
      }else if(prop === 'near') {
        this.camera[prop] = val
      }else if(prop === 'far') {
        this.camera[prop] = val
      }else{
        this.camera[prop][str] = val
      }
      this.camera.updateProjectionMatrix()
      this.controls.update()
    },
    //将当前相机状态保存为初始相机状态
    saveCamera(){
      console.log(this.cPosX)
      this.modelInfo.camera.posX = this.cPosX
      this.modelInfo.camera.posY = this.cPosY
      this.modelInfo.camera.posZ = this.cPosZ
      this.modelInfo.camera.fov = this.cFov
      this.modelInfo.camera.near = this.cNear
      this.modelInfo.camera.far = this.cFar
      console.log(this.modelInfo.camera)
    },
    //操作场景列表来选中场景中的物体
    selectObjFn(str) {
      console.log(str)
      if(str !== 'noSelected') {
        if(this.hasSelected) {
          // this.transformControls.detach(this.selectObj)
        }
        if(str === 'camera' || str === 'ambientlight') {
          this.selectObj = this.scene.getObjectByName(str)
        }else{
          this.selectionBox.visible = true
          this.selectObj = this.scene.getObjectByName(str)
          this.selectionBox.setFromObject(this.selectObj)
          this.transformControls.attach(this.selectObj)
          this.hasSelected = true
        }
      }else{
        if(this.hasSelected) {
          this.transformControls.detach(this.selectObj)
        }
        this.selectionBox.visible = false
        this.hasSelected = false
        this.selectObj = null
      }
    },
    //根据传入之初始灯光
    initLights(lights) {
      this.activeLightType = lights[0].type
      for (let i = 0; i < lights.length; i++) {
        let element = lights[i]
        switch(lights[i].type) {
          case 'AmbientLight':
            let ambientLight = new THREE.AmbientLight(lights[i].color)
            ambientLight.name = lights[i].name
            ambientLight.userData.id = lights[i].id
            this.lightGroup.add(ambientLight)
            break
          case'DirectionalLight':
            let directionalLight = new THREE.DirectionalLight(lights[i].color, lights[i].intensity)
            directionalLight.name = lights[i].name
            directionalLight.userData.id = lights[i].id
            directionalLight.position.set(lights[i].posX, lights[i].posY, lights[i].posZ)
            this.lightGroup.add(directionalLight)
            let directionalLightHelp = new THREE.DirectionalLightHelper(directionalLight, 0.2)
            directionalLightHelp.name = lights[i].name + '_1'
            directionalLightHelp.userData.id = lights[i].id
            this.lightHelpGroup.add(directionalLightHelp)
            break
          default:
            break
        }
      }
    },
    //遍历模型数据 保存到后台
    postModels() {
      this.mesh.traverse((child) => {
        if (child.isMesh) {
          this.modelNames.push(child.name)
          let mat = new THREE.MeshStandardMaterial()
          mat.color = new THREE.Color(0xffffff)
          mat.needsUpdate = true
          child.material = mat
          let jsonGeometry = {}
          jsonGeometry.posX = child.position.x.toFixed(4)
          jsonGeometry.posY = child.position.y.toFixed(4)
          jsonGeometry.posZ = child.position.z.toFixed(4)
          jsonGeometry.rotationX = (child.rotation.x / Math.PI * 180).toFixed(4)
          jsonGeometry.rotationY = (child.rotation.y / Math.PI * 180).toFixed(4)
          jsonGeometry.rotationZ = (child.rotation.z / Math.PI * 180).toFixed(4)
          jsonGeometry.scaleX = child.scale.x.toFixed(4)
          jsonGeometry.scaleY = child.scale.y.toFixed(4)
          jsonGeometry.scaleZ = child.scale.z.toFixed(4)
          jsonGeometry.castShadow = child.castShadow
          jsonGeometry.receiveShadow = child.receiveShadow
          let jsonMaterial = {}
          jsonMaterial.materialType = 'MESHSTANDARDMATERIAL'
          jsonMaterial.color = '#ffffff'
          jsonMaterial.emissive = '#000000'
          jsonMaterial.roughness = 0.5
          jsonMaterial.metalness = 0.5
          jsonMaterial.refractionRatio = 0.98
          jsonMaterial.side = 'FrontSide'
          jsonMaterial.blending = 'NormalBlending'
          jsonMaterial.transparent = false
          jsonMaterial.opacity = 1.0
          jsonMaterial.alphaTest = 0.0
          jsonMaterial.fog = 0.0
          jsonMaterial.depthWrite = true
          jsonMaterial.depthTest = true
          jsonMaterial.wireframe = {
            selected: false,
            wireframeLinecap:'round',
            wireframeLinejoin:'round'
          }
          jsonMaterial.map = {
            url: '',
            selected: false,
            flipY:true,
            magFilter:'LinearFilter',
            minFilter:'LinearMipmapLinearFilter',
            anisotropy: 1
          }
          jsonMaterial.normalMap = {
            url: '',
            selected: false,
            flipY:true,
            scale:1
          }
          jsonMaterial.displacementMap = {
            url: '',
            selected: false,
            flipY:true,
            scale:1,
            bias:0
          }
          jsonMaterial.roughnessMap = {
            url: '',
            selected: false,
            flipY:true
          }
          jsonMaterial.metalnessMap = {
            url: '',
            selected: false,
            flipY:true
          }
          jsonMaterial.envMap = {
            url: '',
            selected: false,
            flipY:true,
            intensity:1
          }
          jsonMaterial.lightMap = {
            url: '',
            selected: false,
            flipY:true,
            intensity:1
          }
          jsonMaterial.aoMap = {
            url: '',
            selected: false,
            flipY:true,
            intensity:1
          }
          jsonMaterial.emissiveMap = {
            url: '',
            selected: false,
            flipY:true,
            intensity:1
          }
          jsonMaterial.alphaMap = {
            url: '',
            selected: false,
            flipY:true
          }
          this.modelInfo.models.push({
            name: child.name,
            type: 'mesh',
            sceneID: this.modelID,
            ...jsonGeometry,
            ...jsonMaterial
          })
        }
      })
      this.nowModelName = this.modelNames[0]
      this.modelInfo.posX = this.mesh.position.x.toFixed(4)
      this.modelInfo.posY = this.mesh.position.y.toFixed(4)
      this.modelInfo.posZ = this.mesh.position.z.toFixed(4)
      this.modelInfo.rotationX = (this.mesh.rotation.x / Math.PI * 180).toFixed(4)
      this.modelInfo.rotationY = (this.mesh.rotation.y / Math.PI * 180).toFixed(4)
      this.modelInfo.rotationZ = (this.mesh.rotation.z / Math.PI * 180).toFixed(4)
      this.modelInfo.scaleX = this.mesh.scale.x.toFixed(4)
      this.modelInfo.scaleY = this.mesh.scale.y.toFixed(4)
      this.modelInfo.scaleZ = this.mesh.scale.z.toFixed(4)
      this.modelInfo.castShadow = this.mesh.castShadow
      this.modelInfo.receiveShadow = this.mesh.receiveShadow
      this.mesh.name = this.modelInfo.name
      this.scene.add(this.mesh)
      this.modelData = zcfCommon.getModelDate(this.mesh,THREE)
      if(this.modelData.r<10){
        this.$message({
          type: 'warn',
          message: '模型尺寸过小，请放大模型再进行其他操作！'
        });
      }
      // https.fetchPost('/AddModels', {
      //   models: this.modelInfo.models
      // }).then(res => {
      //   // console.log(this.modelInfo)
      //   // console.log(res)
      //   // this.modelInfo.models = res.data.result
      //   location.reload()
      //   // this.modelInfo = res.result
      // })
    },
    //根据后台数据设置物体材质
    initChild() {
      // let textureFlipY = true
      // if(this.modelInfo.sceneType === 'gltf') {
      //   textureFlipY = false
      // }
      if(!this.hasAni){
        this.mesh.traverse((child) => {
        if (child.isMesh) {
          let name = child.name
          this.modelNames.push(name)
          let childInfo = this.modelInfo.models.filter(
            item => {
              return item.name === child.name
            }
          )[0]
          child.castShadow = childInfo.castShadow
          child.receiveShadow = childInfo.receiveShadow
          var mat = new THREE.MeshStandardMaterial()
          mat.color = new THREE.Color(childInfo.color)
          mat.roughness = childInfo.roughness
          mat.metalness = childInfo.metalness
          var textrueLoader = new THREE.TextureLoader()
          if(childInfo.map.url !== '' && childInfo.map.selected) {
            var mapTexture = textrueLoader.load(childInfo.map.url)
            mapTexture.encoding = THREE.GammaEncoding
            mapTexture.flipY = childInfo.map.flipY
            mat.map = mapTexture
          }
          if(childInfo.normalMap.url !== '' && childInfo.normalMap.selected) {
            var normalTexture = textrueLoader.load(childInfo.normalMap.url)
            normalTexture.encoding = THREE.GammaEncoding
            normalTexture.flipY = childInfo.normalMap.flipY
            mat.normalMap = normalTexture
            mat.normalScale = new THREE.Vector2(childInfo.normalMap.scale,childInfo.normalMap.scale)
          }
          if(childInfo.metalnessMap.url !== '' && childInfo.metalnessMap.selected) {
            var metalnessTexture = textrueLoader.load(childInfo.metalnessMap.url)
            metalnessTexture.encoding = THREE.GammaEncoding
            metalnessTexture.flipY = childInfo.metalnessMap.flipY
            mat.metalnessMap = metalnessTexture
          }

          if(childInfo.aoMap.url !== '' && childInfo.aoMap.selected) {
            var aoTexture = textrueLoader.load(childInfo.aoMap.url)
            aoTexture.encoding = THREE.GammaEncoding
            aoTexture.flipY = childInfo.aoMap.flipY
            mat.aoMap = aoTexture
          }

          if(childInfo.roughnessMap.url !== '' && childInfo.roughnessMap.selected) {
            var roughnessTexture = textrueLoader.load(childInfo.roughnessMap.url)
            roughnessTexture.encoding = THREE.GammaEncoding
            roughnessTexture.flipY = childInfo.roughnessMap.flipY
            mat.roughnessMap = roughnessTexture
          }
          if(childInfo.alphaMap.url !== '' && childInfo.alphaMap.selected) {
            var alphaMapTexture = textrueLoader.load(childInfo.alphaMap.url)
            alphaMapTexture.encoding = THREE.GammaEncoding
            alphaMapTexture.flipY = childInfo.alphaMap.flipY
            mat.alphaMap = alphaMapTexture
          }
          if(childInfo.envMap.url !== '' && childInfo.envMap.selected) {
            textrueLoader.load(childInfo.envMap.url, (texture) => {
              texture.encoding = THREE.GammaEncoding
              mat.envMap = this.pmremGenerator.fromEquirectangular(texture).texture
              mat.needsUpdate = true
              texture.dispose()
            })
          }
          mat.envMapIntensity = childInfo.envMap.intensity
          mat.transparent = childInfo.transparent
          mat.opacity = childInfo.opacity
          mat.alphaTest = childInfo.alphaTest
          mat.wireframe = childInfo.wireFrame
          mat.needsUpdate = true
          mat.side = this.sideTypes[childInfo.side]
          child.material = mat
          // child.scale.set(childInfo.scaleX, childInfo.scaleY, childInfo.scaleZ)
          // child.position.set(childInfo.posX, childInfo.posY, childInfo.posZ)
          // child.rotation.set(childInfo.rotationX * Math.PI / 180, childInfo.rotationY * Math.PI / 180, childInfo.rotationZ * Math.PI / 180)
          //console.log(child.material)
        }
      })
      }
      
      this.nowModelName = this.modelNames[0]
      this.mesh.scale.set(this.modelInfo.scaleX, this.modelInfo.scaleY, this.modelInfo.scaleZ)
      this.mesh.position.set(this.modelInfo.posX, this.modelInfo.posY, this.modelInfo.posZ)
      this.mesh.rotation.set(this.modelInfo.rotationX/180*Math.PI, this.modelInfo.rotationY/180*Math.PI, this.modelInfo.rotationZ/180*Math.PI)
      this.mesh.castShadow = this.modelInfo.castShadow
      this.mesh.receiveShadow = this.modelInfo.receiveShadow
      this.mesh.name = this.modelInfo.name
      this.modelData = zcfCommon.getModelDate(this.mesh,THREE)
      //console.log(this.modelData)
      this.scene.add(this.mesh)
      this.hasLoaded = true
      for (let i = 0 ; i < this.hotPoints.length; i++){
        this.initHotPiont(this.hotPoints[i],i)
      }
    },
    generateTextureWithText(message) {
      var canvas = document.createElement('canvas')
      var context = canvas.getContext('2d')
      context.font = 'italic small-caps bold 24px Heiti '

      var metrics = context.measureText(message)
      var textWidth = metrics.width
      canvas.width = canvas.height = (textWidth + 40) * 2
      context.fillStyle = 'rgba(127,127,127,1.0)'
      context.strokeStyle = 'rgba(255,255,255,1.0)'
      context.lineWidth = 10
      // this.roundRect(context, 0, 0, canvas.width, canvas.height, 2)
      context.beginPath();
      context.arc(canvas.width/2,canvas.width/2,canvas.width/2-5,0,Math.PI*2,true);
      context.closePath()
      context.fill()
      context.stroke()
      context.fillStyle = 'rgba(255, 255, 255, 1.0)'
      context.font = 'small-caps 60px Heiti'
      context.fillText(message, 36, canvas.height/2+20)
      var texture = new THREE.Texture(canvas);
      texture.format = THREE.RGBAFormat;
      texture.magFilter = THREE.LinearFilter;
      texture.minFilter = THREE.LinearFilter;
      texture.needsUpdate = true;
      return texture;
    },
    initHotPiont(info,num){
      var spriteMap = this.generateTextureWithText(num+1);
      var spriteMaterial = new THREE.SpriteMaterial({
        map: spriteMap,
        color: 0xffffff
      })
      var sprite = new THREE.Sprite(spriteMaterial)
      sprite.scale.set(
        this.modelData.r/80,
        this.modelData.r/80, 
        this.modelData.r/80
      )
      sprite.hotType = info.type
      sprite.position.set(parseFloat(info.posX), parseFloat(info.posY), parseFloat(info.posZ))
      sprite.name = info.title+num
      sprite.userData.type = info.type
      sprite.userData.title = info.title
      sprite.userData.content = info.hotContent
      sprite.userData.cPosX = info.cPosX
      sprite.userData.cPosY = info.cPosY
      sprite.userData.cPosZ = info.cPosZ
      this.hotPointGroup.add(sprite)
    },
    roundRect(ctx, x, y, w, h) {
      ctx.beginPath()
      ctx.moveTo(x, y)
      ctx.lineTo(x + w, y)
      ctx.lineTo(x + w, y + h)
      ctx.lineTo(x, y + h)
      ctx.lineTo(x, y)
      ctx.closePath()
      ctx.fill()
      ctx.stroke()
    },
    tweenCamera(pos, fn) {
      var x = parseFloat(pos.x)
      var y = parseFloat(pos.y)
      var z = parseFloat(pos.z)
      new TWEEN.Tween(this.camera.position)
        .to({ x: x,y:y,z:z }, 1000)
        .easing(TWEEN.Easing.Exponential.InOut)
        .start().onUpdate(function () {
          vm.camera.updateProjectionMatrix()
        }).onComplete(function () {
          if(fn){
            fn()
          }
        })
    },
    // 场景初始
    init () {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.scene.add(this.lightGroup)
      this.scene.add(this.lightHelpGroup)
      this.lightHelpGroup.visible = false
      this.scene.add(this.hotPointGroup)
      this.hotPointGroup.visible = true
      let modelLoader
      console.log(this.modelID)
      https.fetchGet('/GetSceneInfo', {
        id: this.modelID
      }).then(
        res => {
          if(res.status === 200) {
            document.title = res.data.name
            this.modelInfo = res.data
            this.modelName = this.modelInfo.name
            this.bgcolor = this.modelInfo.backGround.color
            this.bgOn = this.modelInfo.backGroundShow
            this.activeBgName = this.modelInfo.backGround.type
            this.activeNum = this.modelInfo.backGround.activeNum
            this.bgActiveImage = this.modelInfo.backGround.url
            this.cFov = this.modelInfo.camera.fov
            this.cNear = this.modelInfo.camera.near
            this.cFar = this.modelInfo.camera.far
            this.cPosX = this.modelInfo.camera.posX
            this.cPosY = this.modelInfo.camera.posY
            this.cPosZ = this.modelInfo.camera.posZ
            if(this.modelInfo.backMusic){
              this.bgms.push(this.modelInfo.backMusic)
              this.bgAudio = this.modelInfo.backMusic.url
              this.$refs.bgAudio.loop = this.modelInfo.backMusic.loop
              this.$refs.bgAudio.volume = this.modelInfo.backMusic.volume/100
              
            }
            this.bgmOn = this.modelInfo.backMusicShow 
            if(this.modelInfo.logo){
              this.logos.push(this.modelInfo.logo)
            }
            this.logoOn = this.modelInfo.logoShow
            this.hotPoints = this.modelInfo.hotPoint
            this.camera = new THREE.PerspectiveCamera(
              this.cFov,
              this.containerW / this.containerH,
              this.cNear,
              this.cFar
            )
            this.camera.position.set(this.cPosX, this.cPosY, this.cPosZ)
            this.camera.name = this.modelInfo.camera.name
            this.scene.add(this.camera)
            this.initLights(this.modelInfo.modelsLight)

            this.renderer = new THREE.WebGLRenderer({
              antialias: true,
              alpha: true
            })
            this.renderer.outputEncoding = THREE.GammaEncoding
            this.renderer.shadowMap.enabled = true
            this.renderer.shadowMap.type = THREE.PCFSoftShadowMap
            this.renderer.setPixelRatio(window.devicePixelRatio)
            this.renderer.setSize(this.containerW, this.containerH)
            // this.renderer.toneMapping = THREE.Uncharted2ToneMapping
            // this.renderer.toneMappingExposure = 0.75

            this.container.appendChild(this.renderer.domElement)

            //controls
            this.controls = new OrbitControls(this.camera, this.renderer.domElement)
            this.controls.enableDamping = true
            this.controls.dampingFactor = 0.1
            this.controls.autoRotate = this.modelInfo.autoRotate
            // this.controls.update()
            this.controls.addEventListener('change', () => {
              this.cPosX = this.camera.position.x.toFixed(4)
              this.cPosY = this.camera.position.y.toFixed(4)
              this.cPosZ = this.camera.position.z.toFixed(4)
            })
            
            this.pmremGenerator = new THREE.PMREMGenerator(this.renderer)
            this.pmremGenerator.compileEquirectangularShader()
            switch(this.modelInfo.sceneType) {
              case 'fbx':
                modelLoader = new FBXLoader()
                modelLoader.load('' + this.modelInfo.modelUrl + '/model.FBX', (object) => {
                // modelLoader.load('models/erji/model.FBX', (object) => {
                  this.mesh = object
                  this.mesh.name = this.modelInfo.name
                  if(this.mesh.animations.length>0){
                    this.controls.autoRotate = false
                    this.hasAni = true
                    this.mixer = new THREE.AnimationMixer( this.mesh );
                    this.action = this.mixer.clipAction( this.mesh.animations[0] );
                    // this.action.play();
                  }
                  // this.scene.add(this.mesh)
                  if(this.modelInfo.models.length <= 0) {
                    this.postModels()
                  }else{
                    this.initChild()
                  }
                })
                break
              case 'gltf':
                modelLoader = new GLTFLoader()
                var dracoLoader = new DRACOLoader()
                dracoLoader.setDecoderPath('com/draco/gltf/')
                modelLoader.setDRACOLoader(dracoLoader)
                modelLoader.setPath(this.modelInfo.modelUrl + '/')
                modelLoader.load('model.gltf', gltf => {
                  this.mesh = gltf.scene
                  if(this.modelInfo.models.length <= 0) {
                    this.postModels()
                  }else{
                    this.initChild()
                  }
                  // var modelData = zcfCommon.getModelDate(this.mesh,THREE);
                  // zcfCommon.initCamera(this.camera,modelData,this.controls);
                })
                break
              case 'obj':
                modelLoader = new MTLLoader()
                modelLoader.setPath(this.modelInfo.modelUrl + '/')
                modelLoader.load('model.mtl', materials => {
                  materials.preload()
                  new OBJLoader()
                    .setMaterials(materials)
                    .setPath(this.modelInfo.modelUrl + '/')
                    .load('model.obj', object => {
                      this.mesh = object
                      console.log(this.mesh)
                      if(this.modelInfo.models.length <= 0) {
                        this.postModels()
                      }else{
                        this.initChild()
                      }
                    })
                })
                break
              default:
                break
            }
            window.addEventListener('resize', this.onresize, false)
        
            this.renderer.domElement.addEventListener('mousedown', this.onMouseDown, false)
            this.renderer.domElement.addEventListener('mouseup', this.onMouseUp, false)
            
            this.renderer.domElement.addEventListener('touchstart', this.onTouchStart, false)
            this.renderer.domElement.addEventListener('touchmove', this.onTouchMove, false)
            this.renderer.domElement.addEventListener('touchend', this.onTouchEnd, false)
            this.animate()
          }else{

          }
        },
        err => {
          console.log(err)
        }).catch(error => {
        console.log(error)
      })
    },
    onTouchStart(event) {
      var array = this.getMousePosition(this.container, event.touches[0].pageX, event.touches[0].pageX)
      this.onDownPosition.fromArray(array)
    },
    onTouchMove(event) {
    },
    onTouchEnd(event) {
      var array = this.getMousePosition(this.container, event.changedTouches[0].clientX, event.changedTouches[0].clientY)
      this.onUpPosition.fromArray(array)
      if (this.onDownPosition.distanceTo(this.onUpPosition) < 1) {
        this.mouse.x = ((event.changedTouches[0].clientX - window.innerWidth) / window.innerWidth) * 2 + 1
        this.mouse.y = -((event.changedTouches[0].clientY - window.innerHeight) / window.innerHeight) * 2 - 1
        this.raycaster.setFromCamera(this.mouse, this.camera)
        let intersections = this.raycaster.intersectObjects(this.hotPointGroup.children, true)
        if(intersections.length > 0) {
          var hotData = intersections[0].object.userData
          console.log(hotData)
          this.tweenCamera({
            x:hotData.cPosX,
            y:hotData.cPosY,
            z:hotData.cPosZ
          },()=>{
            vm.info.title = hotData.title
            vm.info.content = hotData.content
            vm.info.type = hotData.type
            console.log(vm.info)
            switch (hotData.type) {
              case 1:
                vm.infoShow = true
                break;
              case 2:
                location.href = this.info.content
                break;
              case 3:
                vm.infoShow = true
                break;
              case 4:
                vm.infoShow = true
                break;
              case 5:
                vm.infoShow = true
                break;
              default:
                break;
            }
          })
        }
        
      }
    },
    onMouseDown(ev) {
      var array = this.getMousePosition(this.container, ev.clientX, ev.clientY)
      this.onDownPosition.fromArray(array)
    },
    onMouseUp(ev) {
      var array = this.getMousePosition(this.container, ev.clientX, ev.clientY)
      this.onUpPosition.fromArray(array)
      if (this.onDownPosition.distanceTo(this.onUpPosition) === 0) {
        this.mouse.x = ((ev.clientX -this.containerW) / this.containerW) * 2 + 1
        this.mouse.y = -((ev.clientY - this.containerH) / this.containerH) * 2 - 1
        this.raycaster.setFromCamera(this.mouse, this.camera)
        let intersections = this.raycaster.intersectObjects(this.hotPointGroup.children, true)
        if(intersections.length > 0) {
          var hotData = intersections[0].object.userData
          console.log(hotData)
          this.tweenCamera({
            x:hotData.cPosX,
            y:hotData.cPosY,
            z:hotData.cPosZ
          },()=>{
            vm.info.title = hotData.title
            vm.info.content = hotData.content
            vm.info.type = hotData.type
            console.log(vm.info)
            switch (hotData.type) {
              case 1:
                vm.infoShow = true
                break;
              case 2:
                location.href = this.info.content
                break;
              case 3:
                vm.infoShow = true
                break;
              case 4:
                vm.infoShow = true
                break;
              case 5:
                vm.infoShow = true
                break;
              default:
                break;
            }
          })
        }
      }
    },
    //获取鼠标坐标
    getMousePosition(dom, x, y) {
      var rect = dom.getBoundingClientRect()
      return [ (x - rect.left) / rect.width, (y - rect.top) / rect.height ]
    },
    // 窗口改变
    onresize () {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
    },
    // 循环渲染
    render() {
      this.renderer.render(this.scene, this.camera)
    },
    animate () {
      this.rafId = requestAnimationFrame(this.animate)
      // this.hasSelected ? this.transformControls.update() : this.controls.update()
      for(var i = 0; i < this.lightHelpGroup.children.length; i++) {
        this.lightHelpGroup.children[i].update()
      }
      var delta = this.clock.getDelta();
      this.controls.update()
      if ( this.mixer ) {
        this.mixer.update( delta )
      }
      TWEEN.update()
      this.render()
    },
    // 暴露出去的方法
    changeColor () {
      this.mesh.traverse(function (child) {
        if (child.isMesh) {
          child.material.color = new THREE.Color(0xff0000)
        }
      })
    },
    handleUploadSuccess(res, file, str) {
        console.log(res)
        // console.log(file)
        // this[str] = URL.createObjectURL(file.raw);
        this.modelInfo.models[this.nowModelIndex][str].url = res.filePath
        this.changeMatMap(str)
      },
    tabHandleClick(tab, event) {
      // console.log(tab, event)
      this.activeBgName = tab.name
      this.modelInfo.backGround.type = tab.name
      if(this.activeBgName==='image'){
        this.bgActiveNum = 0
        this.bgActiveImage = 'url(images/bgs/1.jpeg)'
        this.modelInfo.backGround.activeNum = 0
        this.modelInfo.backGround.url = 'url(images/bgs/1.jpeg)'
      }else{
        this.bgActiveImage = ''
        this.modelInfo.backGround.url = ''
      }
    },
    lightTypeHandleClick(tab, event){
      console.log(tab, event)
    },
    changeBg(str,val,num){
      if(str==='image'){
        this.bgActiveNum = num
        this.bgActiveImage = 'url('+val+')'
        this.modelInfo.backGround.activeNum = num
        this.modelInfo.backGround.url = 'url('+val+')'
      }else{
        this.bgActiveImage = ''
        this.modelInfo.backGround.url = ''
        this.modelInfo.backGround.color = val
      }
      this.modelInfo.backGround.type=str
    },
    changePanel(num){
      this.activePanelNum = num
      this.selectionBox.visible = false
      this.hasSelected = false
      if(this.selectObj){
        this.transformControls.detach(this.selectObj)
      }
      this.lightHelpGroup.visible = false
      this.hotPointGroup.visible = false
      switch(this.activePanelNum){
        case 1:
          this.lightHelpGroup.visible = true
          this.lightItemActive = 0
          // if(this.modelInfo.modelsLight[this.lightItemActive].type!='AmbientLight'){
          this.selectionBox.visible = false
          this.selectObj = this.scene.getObjectByName(this.modelInfo.modelsLight[this.lightItemActive].name)
          // this.selectionBox.setFromObject(this.selectObj)
          this.transformControls.attach(this.selectObj)
          this.hasSelected = true
          // }
          break;
        case 2:
          this.selectionBox.visible = !this.hideselectedstate
          this.selectObj = this.scene.getObjectByName(this.modelNames[0])
          this.selectionBox.setFromObject(this.selectObj)
          // this.transformControls.attach(this.selectObj)
          this.hasSelected = true
          break;
        case 4:
          this.hotPointGroup.visible = true
          console.log(this.hotPoints)
          if(this.hotPoints.length>0){
            this.hotPointGroup.visible = true
            this.hotPointItemActive = 0
            var pos = new THREE.Vector3(
              this.hotPoints[this.hotPointItemActive].cPosX,
              this.hotPoints[this.hotPointItemActive].cPosY,
              this.hotPoints[this.hotPointItemActive].cPosZ
              )
            this.tweenCamera(pos)
            this.selectionBox.visible = true
            this.selectObj = this.scene.getObjectByName(this.hotPoints[this.hotPointItemActive].title+this.hotPointItemActive)
            this.transformControls.attach(this.selectObj)
            this.hasSelected = true

          }
          break;
        default:
          this.selectionBox.visible = false
          this.transformControls.detach(this.selectObj)
          this.hasSelected = false
          break;
      }
    },
    changeOnClose(str){
      this[str]=!this[str]
      switch(str){
        case 'bgOn':
          if(this.activeBgName=='image'){
            if(this.bgActiveImage==''){
              this.bgActiveImage = 'url(images/bgs/1.jpeg)'
              this.modelInfo.backGround.url = 'url(images/bgs/1.jpeg)'
            }
          }else{
            this.modelInfo.backGround.color=this.bgcolor
          }
          this.modelInfo.backGround.activeNum = this.bgActiveNum
          this.modelInfo.backGroundShow = this.bgOn
          break;
        case 'hideselectedstate':
          if(this.hideselectedstate){
            this.selectionBox.visible = false
            this.transformControls.detach(this.selectObj)
            this.hasSelected = false
          }else{
            this.selectionBox.visible = true
            this.selectObj = this.scene.getObjectByName(this.modelNames[0])
            this.selectionBox.setFromObject(this.selectObj)
            this.transformControls.attach(this.selectObj)
            this.hasSelected = true
          }
          break;
      }
    },
    changeLightItem(num,obj){
      this.lightItemActive = num
      // if(this.modelInfo.modelsLight[this.lightItemActive].type!='AmbientLight'){
        // this.selectionBox.visible = true
      this.selectObj = this.scene.getObjectByName(this.modelInfo.modelsLight[this.lightItemActive].name)
        // this.selectionBox.setFromObject(this.selectObj)
      this.transformControls.attach(this.selectObj)
      this.hasSelected = true
      // }
    },
    changeHotItem(num,obj){
        this.hasSelected = false
        this.transformControls.detach(this.selectObj)
        this.hotPointItemActive = num
        var pos = new THREE.Vector3(
          this.hotPoints[this.hotPointItemActive].cPosX,
          this.hotPoints[this.hotPointItemActive].cPosY,
          this.hotPoints[this.hotPointItemActive].cPosZ
          )
        this.tweenCamera(pos)
        this.selectObj = this.scene.getObjectByName(obj.title+num)
        this.transformControls.attach(this.selectObj)
        this.hasSelected = true
    },
    changeLight(str,val){
      console.log(str,val)
      var light = this.scene.getObjectByName(this.modelInfo.modelsLight[this.lightItemActive].name)

      if(str.substring(0, 8) === 'position'){
        var str1 = str.substring(0, 8)
        var str2 = str.substring(str.length-1)
        light[str1][str2] = val
      }else if(str=='castShadow'){
        this.modelInfo.modelsLight[this.lightItemActive][str] = !this.modelInfo.modelsLight[this.lightItemActive][str]
        light[str] = this.modelInfo.modelsLight[this.lightItemActive][str]
      }else if(str == 'color'){
        light[str].set(val)
      }else{
        light[str] = val
      }
    },
    saveOptions(){
      if(this.bgms.length>0){
        this.modelInfo.backMusic = this.bgms[0]
      }else{
        this.modelInfo.backMusic = null
      }
      this.modelInfo.backMusicShow = this.bgmOn
      if(this.logos.length>0){
        this.modelInfo.logo = this.logos[0]
      }else{
        this.modelInfo.logo = null
      }
      this.modelInfo.logoShow = this.logoOn
      this.modelInfo.hotPoint = this.hotPoints
      console.log(this.modelInfo)
      https.fetchPost('/AddSceneModel', this.modelInfo).then(
        res => {
          if(res.status === 200) {
              this.$message({
                type: 'info',
                message: '保存成功'
              });    
          }else{
              this.$message({
                type: 'info',
                message: '保存失败，请重新保存'
              }); 
          }
        },
        err => {
          console.log(err)
          this.$message({
            type: 'info',
            message: '保存失败，请重新保存'
          }); 
        }).catch(error => {
          console.log(error)
          this.$message({
            type: 'info',
            message: '保存失败，请重新保存'
          }); 
        })
    }
  }
}
</script>
<style>
  @font-face{
      font-family: 'myiconfont';
      src: url('../../public/com/custom-icons.woff') format('woff');
  }
  .el-color-picker__icon{
    display: none!important;
  }
  .el-collapse-item__arrow{
    width:20px;
    height:20px;
    line-height: 20px;
    text-align: center;
    margin:0;
    padding: 0;
    position: relative;
    text-indent: 0
  }
  li{
    list-style: none;
  }
  .el-collapse{
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    margin-bottom:100px;
  }
  .editPanelWrap .el-collapse-item__header{
    background-color: #333 !important;
    border-bottom: 1px solid #000;
    color: #ccc;
    height:30px;
    text-indent: 10px;
  }
  .editPanelWrap .el-collapse-item__wrap{
    border-bottom: 1px solid #000;
  }
  .editPanelWrap .el-collapse-item__content{
    background-color:#595959;
    padding-bottom: 10px;
  }
  .editPanelWrap .el-form-item__label{
    color:#000;
  }
  .editPanelWrap .el-form-item{
    margin-bottom: 10px;
  }
  .editPanelWrap .el-input__inner{
    background-color: #333;
    border: 1px solid #595959;
    color:#fff;
    height:30px;
    box-sizing: border-box;
  }
  .editPanelWrap .el-input-group__prepend{
    color:#aaa;
    height:30px;
    box-sizing: border-box;
  }
  .editPanelWrap .el-input{
    width:200px;
    height:30px;
  }
  .editPanelWrap .el-tabs{
    border-radius: 4px 4px;
    overflow: hidden;
    border: none;
    background-color: #888;
    color:#aaa !important;
  }
  .editPanelWrap .el-tabs__item.is-active{
    background-color: #888!important;
    color:#fff !important;
    border: none !important;
  }
  .editPanelWrap .el-tabs__item{
    background-color: #333 !important;
    color:#aaa !important;
    border: none !important;
  }
  .lightWrap .el-button{
    width:100%;
  }
  .lightWrap .el-card{
    border: 1px solid #666 !important;
  }
  .hotpoint .el-card,.others .el-card{
    border: 1px solid #666 !important;
    overflow: hidden;
  }
  .lightWrap .el-card__body{
    padding: 5px !important;
  }
  .hotpoint .el-card__body,.others .el-card__body{
    padding: 5px !important;
  }
  .hotpoint .hotpointsWrap .el-card__body{
    height: 200px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .lightWrap .el-card__header,.hotpoint .el-card__header,.others .el-card__header{
    padding: 5px !important;
    border-bottom: none;
    background-color: #666;
  }
  .lightWrap .el-card__header span,.hotpoint .el-card__header span,.others .el-card__header span{
    width:100% !important;
    text-align: left;
    text-indent: 5px;
  }
  .el-color-picker__trigger{
    border: none;
  }
  .lightProWrap .el-tabs__item.is-top{
    padding: 0 4px!important;
  }
  /* .el-collapse{
    margin-bottom: 0;
  } */
  .material .item .el-color-picker__trigger{
    width:100px !important;
  }
  .hotpoint .el-scrollbar__wrap{
    overflow-x: hidden;
  }
  .hotpoint .el-scrollbar__view{
    overflow: hidden;
  }
  .hotpoint .item .el-textarea__inner{
    border: none;
    padding: 5px;
    background-color: #333;
    color:#fff;
    text-indent: 12px;
    font-size: 13px;
  }
  .hotpoint .el-button{
    padding: 5px 5px;
  }
  .hotpoint textarea {
    font: normal 13px "微软雅黑";
  }
  .others .el-button {
    width: 100%;
  }   
</style>
<style scoped>
.wrap {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  color: white;
}
.wrap .info{
  height: 100%;
  width: 100%;
  position: absolute;
  left:50%;
  top:50%;
  transform: translateX(-50%) translateY(-50%) scale(0);
  display: none;
}
.wrap .infoWrap{
  min-width: 30%;
  position: absolute;
  left:50%;
  top:50%;
  background-color: rgba(0,0,0,0.5);
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
.wrap .infoWrap img{
  position: relative;
}
.wrap .infoWrap video{
  position: relative;
}
.wrap .infoWrap audio{
  position: relative;
}
.wrap .info h3{
  height:30px;
  position: relative;
  text-align: center;
  line-height: 30px;
}
.wrap .info p{
  width:100%;
  padding-left: 50px;
  padding-right: 50px;
  position: relative;
  box-sizing: border-box;
}
.wrap .info.active{
  display: block;
  animation: infoAni 0.3s ease-in forwards;
}
@keyframes infoAni {
  0%{transform: translateX(-50%) translateY(-50%) scale(0);}
  100%{transform: translateX(-50%) translateY(-50%) scale(1);}
}
.wrap .rightBox{
  position: absolute;
  right:10px;
  top:10px;
  width: 30px;
  background-color: white;
  border-radius: 15px;
}
.wrap .rightBox .btn{
  width:30px;
  height:30px;
  position: relative;
  color:black;
  line-height: 30px;
  text-align: center;
  font-size: 25px;
  cursor: pointer;
  margin-bottom: 5px;
}
.wrap .webgl{
  width: 100%;
  height: 100%;
  position:relative;
  overflow: hidden;
  /* background-image: url(../../public/images/bgs/1.jpeg); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 50%;
  background-position-y: 50%;
}
.wrap .logo{
  position: absolute;
  z-index:999;
}
.loading{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 99;
    left: 0;
    top: 0;
    display: block;
}
.spinner {
    width: 60px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left:-30px;
    margin-top: -30px;
    transform: scale(2);
}

.spinner .container1 > div,.spinner .container2 > div,.spinner .container3 > div {
    width: 12px;
    height: 12px;
    background-color: #fff;

    border-radius: 100%;
    position: absolute;
    -webkit-animation: bouncedelay 1.2s infinite ease-in-out;
    animation: bouncedelay 1.2s infinite ease-in-out;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
}

.spinner .spinner-container {
    position: absolute;
    width: 100%;
    height: 100%;
}

.spinner .container2 {
    -webkit-transform: rotateZ(45deg);
    transform: rotateZ(45deg);
}

.spinner .container3 {
    -webkit-transform: rotateZ(90deg);
    transform: rotateZ(90deg);
}

.spinner .circle1 { top: 0; left: 0; }
.spinner .circle2 { top: 0; right: 0; }
.spinner .circle3 { right: 0; bottom: 0; }
.spinner .circle4 { left: 0; bottom: 0; }

.spinner .container2 .circle1 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
}

.spinner .container3 .circle1 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}

.spinner .container1 .circle2 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}

.spinner .container2 .circle2 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}

.spinner .container3 .circle2 {
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
}

.spinner .container1 .circle3 {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
}

.spinner .container2 .circle3 {
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
}

.spinner .container3 .circle3 {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
}

.spinner .container1 .circle4 {
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
}

.spinner .container2 .circle4 {
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
}

.spinner .container3 .circle4 {
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
}

@-webkit-keyframes bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0.0) }
    40% { -webkit-transform: scale(1.0) }
}

@keyframes bouncedelay {
    0%, 80%, 100% {
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
    } 40% {
          transform: scale(1.0);
          -webkit-transform: scale(1.0);
      }
}
</style>
